export default __webpack_public_path__ + "static/partner-tube-4-37e3feeeaaeace3c0b54259bf08fcf10.png";